import React from 'react';
import Button from 'src/components/Button/Button';
import FontAwesomeIcon from 'src/components/Icon/FontAwesomeIcon';
import './event-actions.scss';

interface IEventActionsProps {
  getEventUrl: () => string;
  getViewButtonLabel: () => string;
}

const EventActions = ({ getEventUrl, getViewButtonLabel }: IEventActionsProps) => (
  <div className="event-actions">
    <a href={getEventUrl()} target="_blank" rel="noopener noreferrer">
      <Button
        color="teal"
        label={getViewButtonLabel()}
        icon={
          <FontAwesomeIcon glyph="external-link" weight="light" size="small" />
        }
        size="small"
      />
    </a>
  </div>
);

export default EventActions;